import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function CodeOfConductSkeleton() {
    return (
        <div className="container mt-5">
            {/* Banner Section Skeleton */}
            <Skeleton height={300} borderRadius={20} className="mb-4" />

            {/* Content Block Skeletons */}
            {[...Array(3)].map((_, idx) => (
                <div key={idx} className="row align-items-center gy-md-5 gy-4 code-conduct-row mb-4">
                    <div className="col-xl-7 col-md-6">
                        <Skeleton height={40} width="60%" borderRadius={10} className="mb-3" />
                        <Skeleton height={120} borderRadius={10} />
                    </div>
                    <div className="col-xl-5 col-md-6">
                        <Skeleton height={300} borderRadius={20} />
                    </div>
                </div>
            ))}
        </div>
    );
}
